import React from 'react';

export default function TripOptions({ props: p, onAction, partId, disabled, dir }) {
  const trips = p.trips || p.items || [];
  const title = p.title || 'Select a trip';

  return (
    <div className="ui-trip-options" dir={dir}>
      <div className="ui-part-title">{title}</div>
      {trips.map((trip) => {
        const id = trip.id ?? trip.scheduledTripId;
        const time = trip.startTimeUtc || trip.departureTime || trip.timeUtc || '';
        const fare = trip.costAmount ?? trip.fare;
        const label = trip.title || `${time} — ${fare != null ? `${fare} AED` : ''}`;
        return (
          <button
            key={id}
            type="button"
            className="ui-trip-option"
            disabled={disabled}
            onClick={() =>
              onAction?.({
                actionId: 'choice.select',
                mode: 'turn',
                payload: {
                  value: id,
                  scheduled_trip_id: id,
                  route_pattern_id: trip.routePatternId,
                  item: trip,
                },
                partId,
              })
            }
          >
            <span className="ui-trip-time">{time}</span>
            {trip.availableSeatCounts && (
              <span className="ui-trip-seats">
                {trip.availableSeatCounts?.Standard ?? trip.availableSeats} seats
              </span>
            )}
            {fare != null && <span className="ui-trip-fare">{fare} AED</span>}
          </button>
        );
      })}
    </div>
  );
}
